export const isDashboardEnabled = async (): Promise<boolean> => {
  const isAdministratorRole = App.isAdministrator() || App.isMasquerading();
  if (!isAdministratorRole) {
    return false;
  }

  const venueId = App.getVenueId();
  const url = `/api/self-sign-up/venue/${venueId}/checklists`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok.');
  }

  const data = await response.json();
  const checklists = data?.checklists ?? [];

  const dashboardChecklist = checklists.find(({ type }) => type === 'SELF_SETUP_DASHBOARD');
  const legacyChecklist = checklists.find(({ type }) => type === 'SELF_SETUP');
  const isVenueLive = App.config.isVenueActive();

  const isChecklistCompleted = (checklist?: {
    tasksCompleted?: boolean;
    checklistCompleted?: boolean;
  }) => Boolean(checklist?.tasksCompleted && checklist?.checklistCompleted);

  // Existing onboarding dashboard flow (covers pending onboarding + live) — unchanged.
  if (dashboardChecklist) {
    return true;
  }

  // Live venues that completed the legacy self-setup checklist (CPG-703).
  if (isVenueLive && isChecklistCompleted(legacyChecklist)) {
    return true;
  }

  // Live venues that never had any checklist at all.
  if (isVenueLive && checklists.length === 0) {
    return true;
  }

  return false;
};
